<script setup lang="ts">
import LabelBase from '@/components/label/LabelBase.vue'
import type { SidebarMenuButton } from '@/types'
import SidebarMainMenuButton from '@/components/sidebar/SidebarMainMenuButton.vue'

defineProps<{
  title?: string
  data: SidebarMenuButton[]
}>()
</script>

<template>
  <label-base v-if="title" class="text-stone-500 font-bold ml-4.25 uppercase" size="sm">{{
    title
  }}</label-base>
  <div class="flex flex-col">
    <sidebar-main-menu-button
      v-for="(button, i) in data"
      :key="i"
      :data="button"
    ></sidebar-main-menu-button>
  </div>
</template>

<style scoped></style>
